import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'

export const CardWrapper = styled.div((props) => {
  const {
    selected,
    cardSize: { width, height = 64 },
    clickable,
    theme: {
      color: { blueLight, grey, greySecondary },
    },
  } = props

  return `
    height: ${height}px;
    padding: 0px;
    border-bottom: 1px solid ${grey};
    display: flex;
    flex-direction: row;
    position: relative;
    
    ${stylesIf(width, `width: ${width}px;`)}
    ${stylesIf(selected, `background-color: ${greySecondary};`)}
    ${stylesIf(clickable, 'cursor: pointer;')}

    &:hover {
      background-color: ${blueLight}; 
    }
  `
})

export const SelectedIndicator = styled.div((props) => {
  const {
    selected,
    height = 64,
    theme: {
      color: { blueAccent },
    },
  } = props

  return `
    ${stylesIf(
      selected,
      `
      position: absolute;
      height: ${height}px;
      width: 6px;
      background-color: ${blueAccent};
    `
    )}
  `
})

export const CardContent = styled.div`
  &&&& {
    padding: 10px 20px;

    > div:first-of-type {
      font-weight: bold;
    }

    > div:last-of-type {
      font-size: 12px;
    }
  }
`
